import { usePage as o } from "@inertiajs/vue3";
const n = (r) => !(Array.isArray(r) && r.length > 0), l = (r) => {
  if (typeof r != "string")
    throw new Error("Please pass only string value");
  if (i())
    return !0;
  let e = o().props.auth ? o().props.auth.permissions ?? [] : [];
  return n(e) ? !1 : !!e.includes(r.trim());
}, p = (r) => !l(r), u = (r) => {
  if (typeof r != "string" && !Array.isArray(r))
    throw new Error("Please pass only string or array value");
  if (i())
    return !0;
  let e = o().props.auth ? o().props.auth.permissions ?? [] : [];
  if (n(e))
    return !1;
  let s = !1;
  return typeof r == "string" ? r.includes("|") ? r.split("|").every(function(t) {
    if (e.includes(t.trim())) {
      s = !0;
      return;
    }
    return !0;
  }) : s = e.includes(r.trim()) : r.every(function(t) {
    if (typeof t == "string" && e.includes(t.trim())) {
      s = !0;
      return;
    }
    return !0;
  }), s;
}, y = (r) => !u(r), f = (r) => {
  if (typeof r != "string" && !Array.isArray(r))
    throw new Error("Please pass only string or array value");
  if (i())
    return !0;
  let e = o().props.auth ? o().props.auth.permissions ?? [] : [];
  if (n(e))
    return !1;
  let s = !1;
  return typeof r == "string" ? r.includes("|") ? (s = !0, r.split("|").forEach(function(t) {
    e.includes(t.trim()) || (s = !1);
  })) : s = e.includes(r.trim()) : (s = !0, r.forEach(function(t) {
    typeof t == "string" && (e.includes(t.trim()) || (s = !1));
  })), s;
}, h = (r) => !f(r), A = () => {
  if (i())
    return !1;
  let r = o().props.auth ? o().props.auth.permissions ?? [] : [];
  return !!n(r);
}, a = (r) => {
  if (typeof r != "string")
    throw new Error("Please pass only string value");
  let e = o().props.auth ? o().props.auth.roles ?? [] : [];
  return n(e) ? !1 : !!e.includes(r.trim());
}, P = (r) => !a(r), c = (r) => {
  if (typeof r != "string" && !Array.isArray(r))
    throw new Error("Please pass only string or array value");
  let e = o().props.auth ? o().props.auth.roles ?? [] : [];
  if (n(e))
    return !1;
  let s = !1;
  return typeof r == "string" ? r.includes("|") ? r.split("|").every(function(t) {
    if (e.includes(t.trim())) {
      s = !0;
      return;
    }
    return !0;
  }) : s = e.includes(r.trim()) : r.every(function(t) {
    if (typeof t == "string" && e.includes(t.trim())) {
      s = !0;
      return;
    }
    return !0;
  }), s;
}, b = (r) => !c(r), g = (r) => {
  if (typeof r != "string" && !Array.isArray(r))
    throw new Error("Please pass only string or array value");
  let e = o().props.auth ? o().props.auth.roles ?? [] : [];
  if (n(e))
    return !1;
  let s = !1;
  return typeof r == "string" ? r.includes("|") ? (s = !0, r.split("|").forEach(function(t) {
    e.includes(t.trim()) || (s = !1);
  })) : s = e.includes(r.trim()) : (s = !0, r.forEach(function(t) {
    typeof t == "string" && (e.includes(t.trim()) || (s = !1));
  })), s;
}, m = (r) => !g(r), R = (r) => {
  if (!Array.isArray(r))
    throw new Error("Please pass only array value");
  let e = o().props.auth ? o().props.auth.roles ?? [] : [];
  return n(e) ? !1 : (r.forEach((s, t) => {
    typeof s == "string" && (r[t] = s.trim());
  }), e.sort().join(",") === r.sort().join(","));
}, d = () => {
  let r = o().props.auth ? o().props.auth.roles ?? [] : [];
  return !!n(r);
}, i = () => {
  let r = o().props.auth ? o().props.auth.roles ?? [] : [], e = o().props.superRoles ?? [];
  return !!(!n(r) && !n(e) && r.some((s) => e.includes(s)));
}, N = () => !i(), w = {
  install: (r) => {
    r.config.globalProperties.can = (e) => l(e), r.config.globalProperties.canNot = (e) => p(e), r.config.globalProperties.canAny = (e) => u(e), r.config.globalProperties.canNotAny = (e) => y(e), r.config.globalProperties.canAll = (e) => f(e), r.config.globalProperties.canNotAll = (e) => h(e), r.config.globalProperties.guest = r.config.globalProperties.hasNoPermissions = () => A(), r.config.globalProperties.is = r.config.globalProperties.hasRole = (e) => a(e), r.config.globalProperties.isNot = r.config.globalProperties.unlessRole = (e) => P(e), r.config.globalProperties.isAny = r.config.globalProperties.hasAnyRole = (e) => c(e), r.config.globalProperties.isNotAny = r.config.globalProperties.unlessAnyRole = (e) => b(e), r.config.globalProperties.isAll = r.config.globalProperties.hasAllRoles = (e) => g(e), r.config.globalProperties.isNotAll = r.config.globalProperties.unlessAllRoles = (e) => m(e), r.config.globalProperties.isExact = r.config.globalProperties.hasExactRoles = (e) => R(e), r.config.globalProperties.hasNoRoles = () => d(), r.config.globalProperties.isSuper = r.config.globalProperties.hasSuperRole = () => i(), r.config.globalProperties.isNotSuper = r.config.globalProperties.unlessSuperRole = () => N();
  }
};
export {
  l as can,
  f as canAll,
  u as canAny,
  p as canNot,
  h as canNotAll,
  y as canNotAny,
  w as default,
  A as guest,
  g as hasAllRoles,
  c as hasAnyRole,
  R as hasExactRoles,
  A as hasNoPermissions,
  d as hasNoRoles,
  a as hasRole,
  i as hasSuperRole,
  a as is,
  g as isAll,
  c as isAny,
  R as isExact,
  P as isNot,
  m as isNotAll,
  b as isNotAny,
  N as isNotSuper,
  i as isSuper,
  m as unlessAllRoles,
  b as unlessAnyRole,
  P as unlessRole,
  N as unlessSuperRole
};
